<p class="infobox empty-data">
  <span class="ico-frown frown"></span> {{ text }}
</p>